import { browser, dev } from '$app/environment'
import Analytics from 'analytics'
import googleAnalytics from '@analytics/google-analytics'
import googleTagManager from '@analytics/google-tag-manager'
import {
    PUBLIC_GOOGLE_TAG_MANAGER_TRACKING_ID,
    PUBLIC_GOOGLE_ANALYTICS_4_TRACKING_ID,
    PUBLIC_GOOGLE_TAG_MANAGER_PREVIEW,
    PUBLIC_GOOGLE_TAG_MANAGER_AUTH,
} from '$env/static/public'
import type { Money, Product } from '$lib/types'
import MoneyLib from 'js-money'

export const analytics =
    browser &&
    Analytics({
        app: 'sirustore',
        plugins: [
            googleAnalytics({
                measurementIds: [PUBLIC_GOOGLE_ANALYTICS_4_TRACKING_ID],
                enabled: false,
            }),
            googleTagManager({
                containerId: PUBLIC_GOOGLE_TAG_MANAGER_TRACKING_ID,
                preview: PUBLIC_GOOGLE_TAG_MANAGER_PREVIEW,
                auth: PUBLIC_GOOGLE_TAG_MANAGER_AUTH,
                enabled: false,
            }),
        ],
    })

export const enableAnalytics = async () => {
    if (dev) return

    analytics.plugins.enable(['google-analytics', 'google-tag-manager']).then(() => {
        console.log('Enabled the analytics plugins')
    })
}

export const reportAnalyticsViewItem = async (product: Product, salePrice: Money) => {
    if (!browser) return

    const priceToUse = salePrice || product.price
    const price = MoneyLib.fromInteger(priceToUse.amount, priceToUse.currency)

    await analytics.track('view_item', {
        value: price.toString(),
        currency: price.currency,
        items: [
            {
                item_id: product.sku,
                item_name: product.name,
                item_brand: product.brand,
                item_category: 'Gift card',
                price: price.toString(),
                quantity: 1,
            },
        ],
    })
}

export const reportAnalyticsCheckout = async (product: Product, salePrice: Money) => {
    if (!browser) return

    const priceToUse = salePrice || product.price
    const price = MoneyLib.fromInteger(priceToUse.amount, priceToUse.currency)

    await analytics.track('add_to_cart', {
        value: price.toString(),
        currency: price.currency,
        items: [
            {
                item_id: product.sku,
                item_name: product.name,
                item_brand: product.brand,
                item_category: 'Gift card',
                price: price.toString(),
                quantity: 1,
            },
        ],
    })

    await analytics.track('begin_checkout', {
        value: price.toString(),
        currency: price.currency,
        items: [
            {
                item_id: product.sku,
                item_name: product.name,
                item_brand: product.brand,
                item_category: 'Gift card',
                price: price.toString(),
                quantity: 1,
            },
        ],
    })
}

export const reportAnalyticsPurchase = async (product: Product, salePrice: Money) => {
    if (!browser) return

    const priceToUse = salePrice || product.price
    const price = MoneyLib.fromInteger(priceToUse.amount, priceToUse.currency)

    await analytics.track('purchase', {
        value: price.toString(),
        currency: price.currency,
        items: [
            {
                item_id: product.sku,
                item_name: product.name,
                item_brand: product.brand,
                item_category: 'Gift card',
                price: price.toString(),
                quantity: 1,
            },
        ],
    })
}
